import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "px-4 py-2"
};
const _hoisted_2 = {
  class: "py-2"
};
const _hoisted_3 = {
  class: "flex flex-row px-4 py-2 space-x-2"
};
const _hoisted_4 = {
  class: "px-4 py-2"
};
const _hoisted_5 = {
  class: "py-2"
};
import LlSwitch from '@/components/LlSwitch.vue';
export default {
  __name: 'ServiceAndExpenseSettings',
  props: {
    updatePdfState: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    function checkLength() {
      props.updatePdfState.errorMessage = '';
      const {
        openingParagraph,
        closingParagraph
      } = props.updatePdfState;
      if (openingParagraph.length > 4095 || closingParagraph.length > 4095) {
        props.updatePdfState.errorMessage = 'Opening or Closing Paragraph cannot exceed 4095 characters.';
      }
    }
    return (_ctx, _cache) => {
      const _component_v_textarea = _resolveComponent("v-textarea");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("hr", {
        style: {
          "margin": "1px"
        }
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createVNode(LlSwitch, {
        label: "Opening Paragraph",
        modelValue: __props.updatePdfState.enableOpeningParagraph,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.updatePdfState.enableOpeningParagraph = $event)
      }, null, 8, ["modelValue"])]), _withDirectives(_createVNode(_component_v_textarea, {
        modelValue: __props.updatePdfState.openingParagraph,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.updatePdfState.openingParagraph = $event),
        rows: "3",
        variant: "outlined",
        onInput: checkLength,
        rules: [v => v.length <= 4095 || 'Opening Paragraph cannot exceed 4095 characters.']
      }, null, 8, ["modelValue", "rules"]), [[_vShow, __props.updatePdfState.enableOpeningParagraph]])]), _createElementVNode("div", null, [_cache[7] || (_cache[7] = _createElementVNode("hr", {
        style: {
          "margin": "1px"
        }
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(LlSwitch, {
        label: "Segment Services by Practice Area",
        modelValue: __props.updatePdfState.enableSegmentByPracticeArea,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.updatePdfState.enableSegmentByPracticeArea = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlSwitch, {
        label: "Segment Expenses by LEDES Code Label",
        modelValue: __props.updatePdfState.enableSegmentByType,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => __props.updatePdfState.enableSegmentByType = $event)
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_4, [_cache[8] || (_cache[8] = _createElementVNode("hr", {
        style: {
          "margin": "1px"
        }
      }, null, -1)), _createElementVNode("div", _hoisted_5, [_createVNode(LlSwitch, {
        label: "Closing Paragraph",
        modelValue: __props.updatePdfState.enableClosingParagraph,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => __props.updatePdfState.enableClosingParagraph = $event)
      }, null, 8, ["modelValue"])]), _withDirectives(_createVNode(_component_v_textarea, {
        modelValue: __props.updatePdfState.closingParagraph,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => __props.updatePdfState.closingParagraph = $event),
        rows: "3",
        variant: "outlined",
        onInput: checkLength,
        rules: [v => v.length <= 4095 || 'Closing Paragraph cannot exceed 4095 characters.']
      }, null, 8, ["modelValue", "rules"]), [[_vShow, __props.updatePdfState.enableClosingParagraph]])])], 64);
    };
  }
};